import "./hide.css";
import { initBrand } from "./initBrand";

// Runs when this module is first imported: before the app renders, so the first paint is the right brand.
initBrand();
export { currentBrand, setTheme } from "./initBrand";
